import type { useForm } from "hooks";
import type { BooleanSwitch, BootstrapableForm } from "types";
import type { OnboardingFormProps } from "ui/forms/ECommerce/Onboarding/types";

export const enum FormField {
    HasMembershipPackages = 'hasMembershipPackages',
    MembershipPackagesInput = 'membershipPackagesInput',
    HasFreeTrial = 'hasFreeTrial',
    FreeTrialInput = 'freeTrialInput',
    HasTangibleGoods = 'hasTangibleGoods',
    MarketingMethods = 'marketingMethods',
    TargetCountries = 'targetCountries',
    HasWebsiteOwnerControl = 'hasWebsiteOwnerControl',
    IsForAnotherBusiness = 'isForAnotherBusiness',
    ForAnotherBusinessInput = 'forAnotherBusinessInput',
    IsProvidingServicesToNotOwnedSites = 'isProvidingServicesToNotOwnedSites',
    ProvidingServicesToNotOwnedSitesInput = 'providingServicesToNotOwnedSitesInput'
};

export type OnboardingMarketingWebsiteAndSupport = {
    readonly [FormField.HasMembershipPackages]: BooleanSwitch | null;
    readonly [FormField.MembershipPackagesInput]: string | null;
    readonly [FormField.HasFreeTrial]: BooleanSwitch | null;
    readonly [FormField.FreeTrialInput]: string | null;
    readonly [FormField.HasTangibleGoods]: BooleanSwitch | null;
    readonly [FormField.MarketingMethods]: string | null;
    readonly [FormField.TargetCountries]: string | null;
    readonly [FormField.HasWebsiteOwnerControl]: BooleanSwitch | null;
    readonly [FormField.IsForAnotherBusiness]: BooleanSwitch | null;
    readonly [FormField.ForAnotherBusinessInput]: string | null;
    readonly [FormField.IsProvidingServicesToNotOwnedSites]: BooleanSwitch | null;
    readonly [FormField.ProvidingServicesToNotOwnedSitesInput]: string | null;
};

export type OnboardingMarketingWebsiteAndSupportBootstrapData = {};

export type OnboardingMarketingWebsiteAndSupportForm = Omit<
    BootstrapableForm<OnboardingMarketingWebsiteAndSupport, OnboardingMarketingWebsiteAndSupportBootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: OnboardingMarketingWebsiteAndSupport;
};

export type OnboardingMarketingWebsiteAndSupportProps =
    & OnboardingFormProps
    & OnboardingMarketingWebsiteAndSupportForm
    & ReturnType<typeof useForm<OnboardingMarketingWebsiteAndSupport>>;
